import {
  FETCH_WALLET_START, FETCH_WALLET_SUCCESS, FETCH_WALLET_ERROR,
  WALLET_WITHDRAW_START, WALLET_WITHDRAW_SUCCESS, WALLET_WITHDRAW_ERROR,
} from '../../Action/actionTypes'

const initialState = {
  unsettled_balance: 0,
  settled_balance:   0,
  withdrawn_balance: 0,
  total_earned:      0,
  transactions:      [],
  loading:           false,
  withdrawLoading:   false,
  error:             null,
}

const walletReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WALLET_START:
      return { ...state, loading: true, error: null }
    case FETCH_WALLET_SUCCESS:
      return { ...state, loading: false, ...action.payload }
    case FETCH_WALLET_ERROR:
      return { ...state, loading: false, error: action.payload }

    case WALLET_WITHDRAW_START:
      return { ...state, withdrawLoading: true }
    case WALLET_WITHDRAW_SUCCESS:
      return { ...state, withdrawLoading: false, ...action.payload }
    case WALLET_WITHDRAW_ERROR:
      return { ...state, withdrawLoading: false }

    default:
      return state
  }
}

export default walletReducer
